import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { RetryError } from "./RetryError";

const PRESETS = [
  "I chose a stable corporate job instead of joining my friend's startup",
  "I stayed in my hometown instead of moving abroad for university",
  "I studied medicine instead of pursuing painting",
];

export const SetupSection = ({ onStart, error, onRetry }) => {
  const [value, setValue] = useState("");
  const canStart = value.trim().length >= 3;

  const submit = (e) => {
    e.preventDefault();
    if (canStart) onStart(value.trim());
  };

  return (
    <motion.section
      data-testid="setup-container"
      initial={{ opacity: 0, scale: 0.97 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.97 }}
      transition={{ duration: 0.3 }}
      className="flex-1 flex flex-col justify-center px-5 sm:px-8 py-10 max-w-2xl mx-auto w-full relative z-10"
    >
      <div className="orb mb-8" style={{ width: 64, height: 64 }} />
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#64748b] mb-3">Parallel timeline · session only</p>
      <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-[1.08] mb-4">
        Talk to the you that chose differently.
      </h1>
      <p className="text-sm sm:text-base text-[#94a3b8] leading-relaxed mb-8 max-w-lg">
        Describe one fork in your life. On the other side is a version of you who took the road you didn't. Ask them anything.
      </p>

      <form onSubmit={submit} className="flex flex-col gap-4">
        <label htmlFor="decision-input" className="text-sm text-[#cbd5e1]">
          Describe a major life decision and the path you didn't take
        </label>
        <textarea
          id="decision-input"
          data-testid="decision-input"
          className="field"
          rows={3}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="I chose to study engineering instead of pursuing music"
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) submit(e);
          }}
        />
        <div className="flex flex-wrap gap-2">
          {PRESETS.map((p, i) => (
            <button key={p} type="button" data-testid={`preset-chip-${i}`} className="chip" onClick={() => setValue(p)}>
              {p}
            </button>
          ))}
        </div>
        {error && <RetryError message={error} onRetry={onRetry} />}
        <button type="submit" data-testid="start-chat-button" className="btn-primary self-start inline-flex items-center gap-2 mt-2" disabled={!canStart}>
          Start Chat <ArrowRight size={16} />
        </button>
      </form>
    </motion.section>
  );
};
